import { Mail, ShieldCheck, MapPin } from "lucide-react";
import { PageHero } from "@/components/common/PageHero";
import { CessionForm } from "@/components/forms/CessionForm";
import { Reveal } from "@/components/common/Reveal";
import { IMAGES } from "@/lib/content";
import { useSeo } from "@/lib/seo";

export default function Contact() {
  useSeo({
    title: "Contact — Échange confidentiel | Losta Group",
    description: "Contactez Losta Group pour un échange confidentiel et sans engagement autour de la transmission ou du développement de votre entreprise. France & Suisse.",
    path: "/contact",
  });
  return (
    <>
      <PageHero
        eyebrow="Contact"
        lines={["Un échange direct", "et confidentiel."]}
        sub="Chaque projet est étudié individuellement. Écrivez-nous ou utilisez le formulaire confidentiel ci-dessous."
        image={IMAGES.swiss}
      />
      <section className="py-16 sm:py-24">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
          <div className="space-y-8">
            <Reveal>
              <div className="rounded-2xl border border-white/10 card-lux p-7">
                <Mail className="h-6 w-6 text-gold" />
                <div className="eyebrow !text-slate-400 mt-4 mb-1">Email confidentiel</div>
                <a href="mailto:contact@losta.group" className="font-serif text-2xl text-white hover:text-gold transition-colors">contact@losta.group</a>
              </div>
            </Reveal>
            <Reveal delay={0.05}>
              <div className="rounded-2xl border border-white/10 card-lux p-7">
                <MapPin className="h-6 w-6 text-gold" />
                <div className="eyebrow !text-slate-400 mt-4 mb-1">Zone d'intervention</div>
                <p className="font-serif text-2xl text-white">France 🇫🇷 · Suisse 🇨🇭</p>
                <p className="text-sm text-slate-400 mt-1">Acquisition · Transmission · Développement</p>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="flex items-start gap-3 rounded-2xl border border-white/10 bg-white/[0.02] p-5">
                <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
                <p className="text-xs text-slate-400 leading-relaxed">
                  Toutes les informations transmises sont traitées de manière strictement confidentielle, uniquement dans le cadre de l'étude d'une éventuelle opération.
                </p>
              </div>
            </Reveal>
          </div>
          <CessionForm />
        </div>
      </section>
    </>
  );
}
